import { createFileRoute, notFound } from '@tanstack/react-router';
import { getCaseStudy, loadCaseStudyBody } from '@content/caseStudies';
import { cmsHead } from '@lib/cmsHead';
import { CaseStudyPage } from '@templates/CaseStudyPage';

export const Route = createFileRoute('/case-studies/$slug')({
  loader: async ({ params }) => {
    const study = getCaseStudy(params.slug);
    if (!study) throw notFound();
    return { study, body: await loadCaseStudyBody(study.slug) };
  },
  head: ({ loaderData }) => (loaderData ? cmsHead(loaderData.study.seo, `/case-studies/${loaderData.study.slug}`) : {}),
  component: CaseStudyRoute,
});

function CaseStudyRoute() {
  const { study, body } = Route.useLoaderData();
  return <CaseStudyPage study={study} body={body} />;
}
